module.exports = __webpack_public_path__ + "0c79c94749524fc459d8130a3b6e760e.png";